import React from "react";
import "./style.scss";
import { Button } from "antd";
import { Form } from "react-final-form";
import moment from "moment";
import FieldSet from "../LayoutComponents/Form/FieldSet";
import FieldSelect from "../LayoutComponents/Form/FieldSelect";
import {
  required,
  mustBeEmail,
  composeValidators
} from "../LayoutComponents/Form/validators";
import FormStateToRedux from "../LayoutComponents/Form/FormStateToRedux";
import Permissions from "../LayoutComponents/Permissions";

import MakeAsyncFunction from "react-redux-promise-listener";
import { promiseListener } from "../../index";

import EmailSearchInput from "./EmailSearchInput";

import { addSubmitForm } from "../../ducks/app";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const _ = require("lodash");
const makeMapStateToProps = () => {
  const mapStateToProps = (state, props) => {
    return {
      isLoading: state.data.loadingUserLookup,
      data:
        state.app.submitForms && state.app.submitForms.users
          ? state.app.submitForms.users
          : { type: "users", attributes: {} }
    };
  };

  return mapStateToProps;
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      addSubmitForm
    },
    dispatch
  );

@connect(
  makeMapStateToProps,
  mapDispatchToProps
)
class UserProfile extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      originalEmail: ""
    };
  }
  componentDidMount() {
    this.setState({
      originalEmail: this.props.user && this.props.user.attributes.email
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.user.id !== this.props.user.id) {
      this.setState({
        originalEmail: this.props.user && this.props.user.attributes.email
      });
    }
  }

  render() {
    let user = this.props.data;

    if (user && user.attributes && user.attributes.birthDate) {
      user.attributes.birthDate = moment(user.attributes.birthDate);
    }
    return user ? (
      <MakeAsyncFunction
        listener={promiseListener}
        start={this.props.startActionType} // the type of action to dispatch when this function is called
        resolve={this.props.resolveActionType} // the type of action that will resolve the promise
        reject={this.props.rejectActionType} // the type of action that will reject the promise
        setPayload={(action, payload) => {
          let user = {
            id:
              this.props.user && this.props.user.id
                ? this.props.user.id
                : undefined,
            type: "users",
            ...payload
          };
          return { ...action, payload: user };
        }}
      >
        {onSubmit => (
          <Form
            initialValues={user}
            onSubmit={onSubmit}
            validate={values => {
              let errors = {};
              if (
                values.attributes &&
                !values.id &&
                values.attributes.email !== values.attributes.confirmEmail
              ) {
                errors = {
                  attributes: {
                    confirmEmail: "Confirmation email does not match email."
                  }
                };
              }
              return errors;
            }}
            render={({ handleSubmit, pristine, invalid, values }) => (
              <form onSubmit={handleSubmit} autoComplete="false">
                <FormStateToRedux form="users" />
                <div className="row form-data">
                  <div className="col-12">
                    {values.attributes.username ? (
                      <FieldSet
                        label="Username"
                        name="attributes.username"
                        disabled={true}
                      />
                    ) : (
                      undefined
                    )}
                    {this.props.showRole && (
                      <div>
                        <FieldSelect
                          label="Role"
                          name="attributes.role"
                          validate={required}
                        >
                          <option />
                          <option value="account_admin">
                            Account Administrator
                          </option>
                          <option value="clinician">Clinician</option>
                          <option value="guest">Guest Clinician</option>
                        </FieldSelect>
                      </div>
                    )}

                    <div className="row">
                      <div className="col-6">
                        <FieldSelect
                          label="Title *"
                          name="attributes.title"
                          validate={required}
                        >
                          <option />
                          <option value="Mr">Mr</option>
                          <option value="Mrs">Mrs</option>
                          <option value="Master">Master</option>
                          <option value="Miss">Miss</option>
                          <option value="Ms">Ms</option>
                          <option value="Mx">Mx</option>
                          <option value="Dr">Dr</option>
                          <option value="Prof">Prof</option>
                        </FieldSelect>
                      </div>
                      <div className="col-6">
                        <FieldSet
                          label="Preferred Name"
                          name="attributes.preferredName"
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-6">
                        <FieldSet
                          label="First Name *"
                          name="attributes.firstName"
                          validate={required}
                        />
                      </div>
                      <div className="col-6">
                        <FieldSet
                          label="Last Name *"
                          name="attributes.lastName"
                          validate={required}
                        />
                      </div>
                    </div>

                    {user.id ? (
                      <FieldSet
                        label="Email *"
                        name="attributes.email"
                        validate={required}
                      />
                    ) : (
                      <div>
                        <label>Email *</label>
                        <EmailSearchInput
                          defaultValue={values.attributes.email}
                        />
                      </div>
                    )}

                    {user &&
                    (!user.id ||
                      this.state.originalEmail !== values.attributes.email) ? (
                      <FieldSet
                        label="Confirm Email *"
                        name="attributes.confirmEmail"
                        validate={composeValidators(required, mustBeEmail)}
                      />
                    ) : (
                      undefined
                    )}
                    <div className="row">
                      <div className="col-6">
                        <FieldSet label="Phone" name="attributes.phone" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="text-right">
                  <Button onClick={this.props.onCancel}>Cancel</Button>
                  <button className="ant-btn ant-btn-primary" type="submit">
                    Save
                  </button>
                </div>
              </form>
            )}
          />
        )}
      </MakeAsyncFunction>
    ) : null;
  }
}

export default UserProfile;

/*<div className="col-12 my-3">
                      <Checkbox.Group style={{ width: "100%" }}>
                        <Row>
                          {this.props.locations &&
                            this.props.locations.map(location => (
                              <Col span={8}>
                                <Checkbox key={location.id} value={location.id}>
                                  {location.attributes.name}
                                </Checkbox>
                              </Col>
                            ))}
                        </Row>
                      </Checkbox.Group>
                    </div>
                    
                    <FieldSet
                      label="Email"
                      name="attributes.email"
                      validate={required}
                      readOnly={
                        user && user.attributes && user.attributes.email
                      }
                    />
                    */



// WEBPACK FOOTER //
// ./src/components/Profile/index.js